import { render } from "./pricesPP.vue?vue&type=template&id=223855b2&scoped=true"
import script from "./pricesPP.vue?vue&type=script&lang=js"
export * from "./pricesPP.vue?vue&type=script&lang=js"

import "./pricesPP.vue?vue&type=style&index=0&id=223855b2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223855b2"]])

export default __exports__